import { MultipleEditPayload, PrebidModuleData, PrebidModuleDataBySite } from '@pubstack/common/src/prebidModule'
import { api } from '~/api/HttpProvider'
import { MutationToasts, useMutation, useQuery } from '~/api/api-client'

const RENDERING_MODULE_QUERY_KEYS = ['adm', 'catalog', 'rendering']
const url = '/adm/catalog/rendering'

//-------------------------------------------------------------------------
// Queries
//-------------------------------------------------------------------------

export const useRenderingModule = (moduleId: string) => {
  return useQuery<PrebidModuleDataBySite<'Rendering'>[]>({
    url: `${url}/${moduleId}`,
    keys: [...RENDERING_MODULE_QUERY_KEYS, moduleId],
    enabled: !!moduleId,
  })
}

//-------------------------------------------------------------------------
// Mutations
//-------------------------------------------------------------------------

export const putRenderingModule = (moduleId: string, siteId: string, data: PrebidModuleData<'Rendering'>, enabled: boolean) => api.put(`${url}/${moduleId}/${siteId}?enabled=${enabled}`, data)

export const useMultipleEditRenderingModule = (moduleId: string, toasts: MutationToasts = {}) => {
  return useMutation<MultipleEditPayload<'Rendering'>>({
    method: 'put',
    url: `${url}/multipleEdit/${moduleId}`,
    collectionKeys: [...RENDERING_MODULE_QUERY_KEYS, moduleId],
    ...toasts,
  })
}
